import { ControlPosition, MapControl, useMap } from '@vis.gl/react-google-maps';
import { useState } from 'react';
import classes from './map-type-control.module.css';
import roadmapImageUrl from './roadmap.webp?inline';
import satelliteImageUrl from './satellite.webp?inline';
import { ResetMapButton } from '@/ui/reset-map-button/reset-map-button';

const MapTypeId = {
  roadmap: 'roadmap',
  satellite: 'hybrid',
};

export function MapTypeControl({ position = ControlPosition.RIGHT_BOTTOM }) {
  const map = useMap();
  const [mapTypeId, setMapTypeId] = useState(map?.getMapTypeId() ?? MapTypeId.roadmap);
  const controlModifierClass = mapTypeId !== MapTypeId.satellite ? classes.controlDark : '';
  const imageUrl = mapTypeId !== MapTypeId.satellite ? satelliteImageUrl : roadmapImageUrl;
  const label = mapTypeId !== MapTypeId.satellite ? 'Satellite view' : 'Roadmap view';

  const toggleMapType = () => {
    if (map) {
      const newMapTypeId = mapTypeId !== MapTypeId.satellite ? MapTypeId.satellite : MapTypeId.roadmap;
      map.setMapTypeId(newMapTypeId);
      setMapTypeId(newMapTypeId);
    }
  };

  return (
    <MapControl position={position}>
      <div className={`${classes.control} ${controlModifierClass}`}>
        <ResetMapButton />
        <button type="button" className={classes.toggleBtn} onClick={toggleMapType} aria-label={label}>
          <div style={{ backgroundImage: `url(${imageUrl})` }} />
        </button>
        <div className={classes.hover} />
      </div>
    </MapControl>
  );
}
